import { createContext } from 'react';

import { type TTheme } from '@app-types/theme';

export interface IThemeContextValue {
  theme: TTheme;
  setTheme: (theme: TTheme) => void;
  toggleTheme: () => void;
  systemTheme: TTheme;
}

export const ThemeContext = createContext<IThemeContextValue | undefined>(undefined);
